import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface Feedback {
  id: string;
  planId: string;
  rating: number;
  comment: string;
  createdAt: string;
}

interface FeedbackStore {
  feedbacks: Feedback[];
  addFeedback: (feedback: Omit<Feedback, 'id' | 'createdAt'>) => void;
  getFeedbackForPlan: (planId: string) => Feedback | undefined;
}

export const useFeedbackStore = create<FeedbackStore>()(
  persist(
    (set, get) => ({
      feedbacks: [],
      addFeedback: (feedback) => set((state) => ({
        feedbacks: [
          ...state.feedbacks,
          {
            ...feedback,
            id: crypto.randomUUID(),
            createdAt: new Date().toISOString()
          }
        ]
      })),
      getFeedbackForPlan: (planId) => 
        get().feedbacks.find((feedback) => feedback.planId === planId)
    }),
    {
      name: 'feedback-storage'
    }
  )
);